import * as React from "react";
import Svg, { Circle } from "react-native-svg";

function SvgComponent({ width = 26, height = 26, color = "#5BE068", style }) {
  return (
    <Svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <Circle cx={13} cy={13} r={11} fill={color} />
      <Circle cx={13} cy={13} r={13} fill={color} fillOpacity={0.2} />
    </Svg>
  );
}

export default SvgComponent;
